import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { useHistory, useLocation } from 'react-router-dom';

import { selectNotificationState } from '../../../redux/notification/notificationSelectors';

import Icon from '../../Icon/Icon';

const NotificationButton = ({ notificationState, mobile }) => {
  const history = useHistory();
  const location = useLocation();
  const isNotificationsPage = location.pathname === '/notifications';

  const handleClick = () => {
    if (mobile) {
      history.push('/notifications');
      return;
    }
    history.push('/notifications');
  };

  return (
    <div style={{ position: 'relative', height: '100%' }}>
      <button
        className="notification-button"
        type="button"
        onClick={handleClick}
      >
        <Icon
          icon={isNotificationsPage ? 'notifications' : 'notifications-outline'}
          style={{ cursor: 'pointer' }}
        />
        {notificationState.unreadCount > 0 && (
          <span className="notification-button__badge">
            {Math.min(99, notificationState.unreadCount)}
          </span>
        )}
      </button>
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  notificationState: selectNotificationState,
});

export default connect(mapStateToProps)(NotificationButton);
